import Header from "../../shared/ArtistHeader/header";
import Footer from "../../shared/footer/footer";
import DmicComponent from "../../shared/Dmic/DmicComponent";

const Dmic = () => {
	return (
		<div>
			<Header />
			<DmicComponent />
			<Footer />
		</div>
	);
};

export default Dmic;
